const React = require('react')
const Helpers = require('../../../../../_plugins/lib/helpers')
const EmailDiscountForm = require('./EmailDiscountForm.jsx')
const createReactClass = require('create-react-class');

const ExitDiscountModal = createReactClass({

  getInitialState () {
    return {
      active: false,
      validAgentCode: false,
      redirect: ''
    }
  },

  componentDidMount () {
    const { agentData: { agent } } = this.props
    const validAgentCode = ['WX425', 'WW783'].indexOf(agent) > -1
    const redirect = this.composeRedirect()
    if (!Helpers.getCookie('exit_discount_modal_already_seen')) {
      document.addEventListener('mousemove', this.activateModal)
    }
    this.setState({ validAgentCode, redirect })
  },

  componentWillUnmount () {
    document.removeEventListener('mousemove', this.activateModal)
  },

  composeRedirect () {
    const agentRegex = /agent=([A-Z])/
    if (agentRegex.test(window.location.href)) {
      // Already an agent in url
      // (This is safe because the only agent codes that will
      // trigger the modal ('WX425', 'WW783') are safe to replace)
      return window.location.href.replace(agentRegex, 'agent=AZ385')
    } else if (window.location.href.indexOf('?') < 0) {
      // If there are no parameters in url
      return `${window.location.href}?agent=AZ385`
    } else {
      return `${window.location.href}&agent=AZ385`
    }
  },

  activateModal (e) {
    if (this.shouldActivateModal(e)) {
      $('#footer').addClass('not-interactive')
      this.setState({ active: true })
    }
  },

  deactivateModal (e) {
    e.preventDefault()
    this.registerModalCookie()
    $('#footer').removeClass('not-interactive')
    this.setState({ active: false })
  },

  shouldActivateModal (e) {
    if (!this.hasMouseMovedOffScreen(e)) return false
    // We only want the modal to appear once, so after it appears
    // remove the event listener
    document.removeEventListener('mousemove', this.activateModal)
    return true
  },

  hasMouseMovedOffScreen (e) {
    // MouseEvent.movementY is not suported on IE, so
    // create variable mouseDeltaY to emulate it.
    const prevPositionY = this.prevMousePositionY || 0
    this.prevMousePositionY = e.pageY
    const mouseDeltaY = e.pageY - prevPositionY

    const mouseHasMovedUp = mouseDeltaY < 0
    const mouseAboveWindow = (e.pageY - window.pageYOffset) - Math.abs(mouseDeltaY) < 0
    return mouseHasMovedUp && mouseAboveWindow
  },

  registerModalCookie () {
    Helpers.setCookie('exit_discount_modal_already_seen', '1')
  },

  render () {
    const { imageCloudSettings, pageData } = this.props
    const { active, validAgentCode } = this.state
    const { imageCloudCDN, imageCloudWebsite } = imageCloudSettings
    const CSSDisplay = active ? 'block' : 'none'
    const backGroundImgSrc = `${imageCloudCDN}/${imageCloudWebsite}/modal-images/backgrounds/exit-discount-modal/recent.jpg`
    return validAgentCode && (
      <div style={{ display: CSSDisplay }}>
        <div
          className='modal-exit-discount-overlay'
          data-hxtrack-name='dismiss-exit-discount-modal'
          onClick={this.deactivateModal}
        />
        <div className='modal-exit-discount-main'>
          <img className='modal-exit-discount-image' src={backGroundImgSrc} />
          <a
            href='#'
            className='modal-exit-discount-dismiss'
            data-hxtrack-name='dismiss-exit-discount-modal'
            onClick={this.deactivateModal}
          >
            +
          </a>
          <EmailDiscountForm pageData={pageData}/>
        </div>
      </div>
    )
  }
})

module.exports = ExitDiscountModal




// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/modals/ExitDiscountModal.jsx